export class AlimentoModel {
    nombre: string; 
    categoria: string; 
    super: string;
    marca: string; 
    porcion: number;
    unidad: string; 
    calorias: number; 
    carbohidratos: number;
    azucar: number;
    fibra: number;
    proteinas: number;
    grasaTotal: number;
    grasaSaturada: number;
    grasaMonoinsaturada: number;
    grasaPoliinsaturada: number;
    grasaTrans: number;
    colesterol: number;
    imagen?: {
        nombre: string;
        url: string;
    };
    imagenEtiqueta?: {
        nombre: string;
        url: string;
    };
    informacion: string;
    propietario: string;
    activo: boolean; // bandera que sirve para aliminar elemento
    empresaId: string;
}

export const categoriasAlimento = [
    'Aceites y grasas con proteínas',
    'Aceites y grasas sin proteínas',
    'AOA - Alto aporte de grasa',
    'AOA - Bajo aporte de grasa',
    'AOA - Moderado aporte de grasa',
    'AOA - Muy bajo aporte de grasa',
    'Azúcares con grasa',
    'Azúcares sin grasa',
    'Bebidas alcohólicas',
    'Cereales con grasa',
    'Cereales sin grasa',
    'Frutas',
    'Leche con azúcar',
    'Leche descremada',
    'Leche entera',
    'Leche semidescremada',
    'Leguminosas',
    'Libres',
    'Otros alimentos',
    'Verduras',
];

export const superAlimentos = [
    'Aceites y aderezos',
    'Carnes frías',
    'Carnes y aves',
    'Especias y condimentos',
    'Frutas y verduras',
    'Lácteos y huevo',
    'Latería',
    'Leguminosas',
    'Pan, pasta y cereales',
    'Pescados y mariscos',
    'Semillas y frutos secos',
    'Vinos y licores',
    'Varios',
];

export const unidadesAlimentos: string[] = [
    'barra',
    'cápsula',
    'cucharada',
    'cucharadita',
    'diente',
    'g',
    'lata',
    'lata 120 g',
    'manojo',
    'mg',
    'mitad',
    'ml',
    'pastilla',
    'pieza',
    'rebanada',
    'rodaja',
    'scoop',
    'sobre',
    'spray',
    'tableta',
    'tallo',
    'taza',
];
